//
// Scroll to next section
// 

// Hero - btn scroll to next section
var fn_scroll_next_section = function () {

    $(".js-scroll-to-next-section").on("click", function(){
        var sectionNext = $(this).closest('.section').next();

        $("html, body").animate({
            scrollTop: sectionNext.offset().top - 100
        }, 700);
    });

};